import { Component, Inject, SecurityContext, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { Terms } from '../../../models/terms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-terms-acceptance-modal',
    templateUrl: './terms-acceptance-modal.component.html',
    styleUrls: ['./terms-acceptance-modal.component.scss'],
    imports: [MatButton, MatDialogTitle, MatDialogContent, MatDialogActions]
})
export class TermsAcceptanceModalComponent implements AfterViewInit {

    private static readonly SCROLL_THRESHOLD = 10;

    @ViewChild('scrollContainer', { read: ElementRef }) scrollContainer?: ElementRef;

    public term: Terms;
    public sanitizedText: SafeHtml;
    public hasScrolledToEnd = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) data: { term: Terms },
        private dialogRef: MatDialogRef<TermsAcceptanceModalComponent>,
        private sanitizer: DomSanitizer
    ) {
        this.term = data.term;
        const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, data.term.text);
        if (sanitized === null) {
            console.error('Failed to sanitize terms text for term:', data.term.id);
            const fallbackText = $localize`Unable to display terms content. Please contact support.`;
            this.sanitizedText = this.sanitizer.sanitize(SecurityContext.HTML, fallbackText) || 
                                  'Unable to display terms content. Please contact support.';
        } else {
            this.sanitizedText = sanitized;
        }
    }

    ngAfterViewInit(): void {
        // Check if content needs scrolling after view is fully rendered
        setTimeout(() => {
            if (this.scrollContainer) {
                const element = this.scrollContainer.nativeElement;
                // If content fits without scrolling, enable accept button immediately
                if (element.scrollHeight <= element.clientHeight) {
                    this.hasScrolledToEnd = true;
                }
            }
        }, 0);
    }

    onScroll(event: Event): void {
        const element = event.target as HTMLElement;
        const scrollPosition = element.scrollTop + element.clientHeight;
        const scrollHeight = element.scrollHeight;
        
        // Consider scrolled to end if within threshold of bottom
        if (scrollHeight - scrollPosition <= TermsAcceptanceModalComponent.SCROLL_THRESHOLD) {
            this.hasScrolledToEnd = true;
        }
    }

    accept(): void {
        this.dialogRef.close(true);
    }

    decline(): void {
        this.dialogRef.close(false);
    }
}
